<template>
  <div class="register-nav">
    <div class="register-main">
      <div>
        <img
          v-if="VUE_APP_VERSION == 'hprt'"
          class="register-left-img1 here-logo"
          src="../../assets/here/here-logo.png"
          alt=""
        />
        <img
          v-else
          class="register-left-img1"
          src="../../assets/logo.png"
          alt=""
        />
      </div>
      <div class="register-content">
        <div class="register-left loginPic"></div>
        <div class="register-right">
          <div class="register-right-head">
            <div class="register-title">{{ $t(`button.register`) }}</div>
            <div class="register-title-right">
              {{ $t(`tips.tip33`)
              }}<span
                style="color: #003591; cursor: pointer"
                @click="toLogin('/login')"
                >{{ $t(`button.goLogin`) }}</span
              >
            </div>
          </div>
          <a-form ref="formRef" :model="formState" :rules="rules">
            <a-form-item name="username">
              <a-input
                :class="errArray.errName ? 'errStyle' : ''"
                v-model:value="formState.username"
                :placeholder="$t(`tips.tip12`)"
              />
            </a-form-item>
            <a-form-item name="phone" v-if="!isEmail">
              <a-input
                @input="inputAccount"
                :class="errArray.errAccount ? 'errStyle' : ''"
                v-model:value="formState.phone"
                :placeholder="$t(`tips.tip13`)"
              />
            </a-form-item>
            <a-form-item name="email" v-else>
              <a-input
                @input="inputAccount"
                :class="errArray.errAccount ? 'errStyle' : ''"
                v-model:value="formState.email"
                :placeholder="$t(`tips.tip17`)"
              />
            </a-form-item>
            <a-form-item name="code">
              <a-input
                :class="errArray.errCode ? 'errStyle' : ''"
                v-model:value="formState.code"
                :placeholder="$t(`tips.tip8`)"
              />
              <div class="register-postion-abs">
                <a-button @click="handleGetCode" v-if="timer > 59">{{
                  $t(`button.getCode`)
                }}</a-button>
                <a-button v-else>{{ timer }}</a-button>
              </div>
            </a-form-item>
            <a-form-item name="password">
              <a-input-password
                :class="errArray.errPassw ? 'errStyle' : ''"
                v-model:value="formState.password"
                :placeholder="$t(`tips.tip14`)"
                autocomplete="off"
              />
            </a-form-item>
            <a-form-item name="repassword">
              <a-input-password
                :class="errArray.errRePassw ? 'errStyle' : ''"
                @input="rePassWord"
                v-model:value="formState.repassword"
                :placeholder="$t(`tips.tip15`)"
                autocomplete="off"
              />
            </a-form-item>
            <a-form-item name="industry">
              <a-select
                :class="errArray.errIndustry ? 'errStyle' : ''"
                style="width: 480px"
                v-model:value="formState.industry"
                :options="industryList"
                :placeholder="$t(`tips.tip16`)"
              >
              </a-select>
            </a-form-item>
            <a-form-item name="customTrade" v-if="formState.industry == 0">
              <a-input
                :class="errArray.errCustom ? 'errStyle' : ''"
                v-model:value="formState.customTrade"
                :placeholder="$t(`tips.tip6`)"
              />
            </a-form-item>
          </a-form>
          <div class="register-btn">
            <a-button @click="onSubmit">{{ $t(`button.register`) }}</a-button>
          </div>
          <div class="change-btn">
            <span
              style="cursor: pointer"
              v-if="!isEmail"
              @click="registerMethod"
              >{{ $t(`button.useEmail`) }}</span
            >
            <span style="cursor: pointer" v-else @click="registerMethod">{{
              $t(`button.usePhone`)
            }}</span>
          </div>
          <div class="register-check-box">
            <a-checkbox
              v-model:checked="checked"
              @change="readChange"
            ></a-checkbox>
            {{ $t(`label.label47`)
            }}<span
              style="color: #003591; cursor: pointer"
              @click="handleOpenAgreement(0)"
              >{{ $t(`label.label48`) }}</span
            >{{ $t(`label.label49`)
            }}<span
              style="color: #003591; cursor: pointer"
              @click="handleOpenAgreement(1)"
              >{{ $t(`label.label50`) }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="beihao">
      Xiamen Hanin Co.,Ltd. ALL RIGHTS RESERVED.
      ©2016-{{new Date().getFullYear()}}
      <a
        v-if="VUE_APP_VERSION == 'hprt'"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        >闽ICP备17017244号-2</a
      >
      <a
        v-else
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        >闽ICP备17017244号-5</a
      >
    </div>
    <Verification ref="verificationRef" @send="getPhoneCode"></Verification>
  </div>
</template>

<script>
import Verification from "../../components/Verification.vue";
import { useRouter } from "vue-router";
import { setAuthorization } from "@/utils/request";
import { message } from "ant-design-vue";
import { validateMobilePhone, validateMobileEmail } from "@/utils/validate";
import { getSign } from "@/utils/signature";
import {
  defineComponent,
  getCurrentInstance,
  onMounted,
  reactive,
  watch,
  ref,
  toRaw,
  toRefs,
  nextTick,
} from "vue";
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default defineComponent({
  components: {
    Verification,
  },
  setup() {
    const router = useRouter();
    const { proxy } = getCurrentInstance();
    let globalProperties =
      getCurrentInstance().appContext.config.globalProperties;
    const axios = globalProperties.$axios;

    //表单校验规则
    let validatePassword = async (rule, value) => {
      if (value === "") {
        return Promise.reject(proxy.$t(`tips.tip15`));
      } else if (value !== state.formState.password) {
        return Promise.reject(proxy.$t(`tips.tip22`));
      } else {
        return Promise.resolve();
      }
    };

    const state = reactive({
      formRef: null,
      textTime: null,
      errArray: {
        errName: false,
        errAccount: false,
        errCode: false,
        errPassw: false,
        errRePassw: false,
        errIndustry: false,
        errCustom: false,
      },
      formState: {
        username: "",
        password: "",
        repassword: "",
        code: "",
        phone: "",
        email: "",
        industry: undefined,
        customTrade: "",
      },
      rules: {
        username: {
          required: true,
          message: proxy.$t(`tips.tip12`),
          trigger: "change",
        },
        phone: {
          required: true,
          validator: validateMobilePhone,
          trigger: "change",
        },
        code: {
          required: true,
          message: proxy.$t(`tips.tip8`),
          trigger: "change",
        },
        email: {
          required: true,
          validator: validateMobileEmail,
          trigger: "change",
        },
        password: {
          required: true,
          message: proxy.$t(`tips.tip11`),
          trigger: "change",
        },
        repassword: {
          required: true,
          validator: validatePassword,
          trigger: "change",
        },
        industry: {
          required: true,
          message: proxy.$t(`tips.tip16`),
          trigger: "change",
        },
        customTrade: {
          required: true,
          message: proxy.$t(`tips.tip6`),
          trigger: "change",
        },
      },
      industryList: [],
      isEmail: false,
      checked: false,
      VUE_APP_VERSION: process.env.VUE_APP_VERSION,
      verificationRef: null,
      language: proxy.$i18n.locale,
    });

    onMounted(() => {
      let language = proxy.$i18n.locale;
      if (language != "zh") {
        state.isEmail = true;
      }
      var timestamp = Date.parse(new Date());
      timestamp = timestamp / 1000;
      let param = {
        timestamp,
        fun: "getTrade",
        requestType: "User",
        appId: "a0f0e723-f2bb-11e8-bc50-00163e0c395e",
        appKey: "a0f12ce4-f2bb-11e8-bc50-00163e0c395e",
      };
      var signature = getSign(param);
      let data = JSON.parse(JSON.stringify(param));
      data.signature = signature;

      //获取行业
      axios("/api/apiservice/apiroute", data).then((res) => {
        let array = [];
        res.forEach((e) => {
          let sur = {
            value: String(e.id),
            label: e.name,
          };
          array.push(sur);
        });
        state.industryList = array;
      });
    });

    //监听language的变化
    watch(
      () => proxy.$i18n.locale,
      () => {
        state.language = proxy.$i18n.locale;
      }
    );

    //打开隐私协议
    const handleOpenAgreement = (val) => {
      let lang = state.language == 'zh' ? 'zh' : 'en'
      let host = 'https://hm.hprt.com/'
      if(state.VUE_APP_VERSION == "hprt"){
        host = 'https://hm.hprt.com/'
      }else{
        host = 'https://hm.hprt.com/'
      }

      if(val == 0){
        window.open(`${host}hmapp/protocol.html?id=1&lang=${lang}`)
      }else if(val == 1){
        window.open(`${host}hmapp/protocol.html?id=4&lang=${lang}`)
      }
    };

    //切换手机或邮箱登录
    const registerMethod = () => {
      state.isEmail = !state.isEmail;
      resetForm();
    };

    const inputAccount = (e) => {
      clearTimeout(state.textTime);
      state.errArray.errAccount = false;
      state.textTime = setTimeout(() => {
        if (e.target.value == "") {
          state.errArray.errAccount = true;
        } else {
          if (state.isEmail) {
            var reg1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
          } else {
            var reg1 = /^1([3456789])\d{9}$/;
          }
          if (!reg1.test(e.target.value)) {
            state.errArray.errAccount = true;
          } else {
            state.errArray.errAccount = false;
          }
        }
        setTimeout(() => {
          state.errArray.errAccount = false;
        }, 1000);
        state.textTime = null;
      }, 600);
    };
    const rePassWord = (e) => {
      clearTimeout(state.textTime);
      state.errArray.errRePassw = false;
      state.textTime = setTimeout(() => {
        if (e.target.value == "") {
          state.errArray.errRePassw = true;
        } else {
          if (e.target.value != state.formState.password) {
            state.errArray.errRePassw = true;
          } else {
            state.errArray.errRePassw = false;
          }
        }
        setTimeout(() => {
          state.errArray.errRePassw = false;
        }, 1000);
        state.textTime = null;
      }, 600);
    };

    //获取验证码
    let timer = ref(60);
    let codeTimer = "";
    const handleGetCode = () => {
      var timestamp = Date.parse(new Date());
      timestamp = timestamp / 1000;
      if (state.isEmail) {
        let { email, code } = toRaw(state.formState);
        if (!email) {
          message.error(proxy.$t(`tips.tip17`));
          return;
        } else {
          var reg2 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
          if (!reg2.test(email)) {
            message.error(proxy.$t(`tips.tip21`));
            return;
          }
          let param = {
            fun: "sendEmail",
            timestamp,
            requestType: "User",
            appId: "a0f0e723-f2bb-11e8-bc50-00163e0c395e",
            email,
            event: 1,
            appKey: "a0f12ce4-f2bb-11e8-bc50-00163e0c395e",
          };
          var signature = getSign(param);
          var form = JSON.parse(JSON.stringify(param));
          form.signature = signature;
          axios("/api/apiservice/apiroute", form).then((res) => {
            message.success(proxy.$t(`tips.tip54`));
            codeTimer = setInterval(() => {
              if (timer.value > 1) {
                timer.value--;
              } else {
                timer.value = 60;
                clearInterval(codeTimer);
              }
            }, 1000);
          });
        }
      } else {
        let { phone } = toRaw(state.formState);
        if (!phone) {
          message.error(proxy.$t(`tips.tip13`));
          return;
        } else {
          var reg1 = /^1([3456789])\d{9}$/;
          if (!reg1.test(phone)) {
            message.error(proxy.$t(`tips.tip20`));
            return;
          }
          state.verificationRef.showDia(1);
        }
      }
    };

    const getPhoneCode = (verify_code, session_id) => {
      var timestamp = Date.parse(new Date());
      timestamp = timestamp / 1000;
      let { phone } = toRaw(state.formState);
      let param = {
        fun: "newSmsValidate",
        timestamp,
        requestType: "User",
        appId: "a0f0e723-f2bb-11e8-bc50-00163e0c395e",
        phone,
        smsType: 1,
        verify_code,
        session_id,
        appKey: "a0f12ce4-f2bb-11e8-bc50-00163e0c395e",
      };
      var signature = getSign(param);
      var form = JSON.parse(JSON.stringify(param));
      form.signature = signature;
      axios("/api/apiservice/apiroute", form).then((res) => {
        message.success(proxy.$t(`tips.tip54`));
        codeTimer = setInterval(() => {
          if (timer.value > 1) {
            timer.value--;
          } else {
            timer.value = 60;
            clearInterval(codeTimer);
          }
        }, 1000);
      });
    };

    //是否勾选已阅读
    const readChange = (e) => {
      state.checked = e.target.checked;
    };

    //注册
    const onSubmit = () => {
      state.formRef
        .validate()
        .then(() => {
          if (state.isEmail) {
            var accountType = 2;
          } else {
            var accountType = 1;
          }
          var timestamp = Date.parse(new Date());
          timestamp = timestamp / 1000;

          let code = state.formState.code;
          let email = state.formState.email;
          let phone = state.formState.phone;
          let userName = state.formState.username;
          let password = state.formState.password;
          let trade = state.formState.industry;

          let param = {
            accountType,
            address: "无",
            appId: "a0f0e723-f2bb-11e8-bc50-00163e0c395e",
            appKey: "a0f12ce4-f2bb-11e8-bc50-00163e0c395e",
            code,
            fun: "newestRegister",
            email,
            password,
            phone,
            requestType: "User",
            source: 1,
            thirdType: 1,
            timestamp,
            trade,
            userName,
            userType: 1,
          };
          if (trade == 0) {
            param["customTrade"] = state.formState.customTrade;
          }

          var signature = getSign(param);
          let obj = JSON.parse(JSON.stringify(param));
          obj.signature = signature;
          if (state.checked) {
            axios("/api/apiservice/apiroute", obj)
              .then((res) => {
                message.success(proxy.$t(`tips.tip55`));
                resetForm();
                router.push("/Login");
              })
              .catch((err) => {});
          } else {
            message.error(proxy.$t(`tips.tip19`));
          }
        })
        .catch((error) => {
          var rel1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
          var rel2 = /^1([3456789])\d{9}$/;
          if (state.formState.username == "") {
            state.errArray.errName = true;
          }
          if (state.isEmail) {
            if (!rel1.test(state.formState.email)) {
              state.errArray.errAccount = true;
            }
          } else {
            if (!rel2.test(state.formState.phone)) {
              state.errArray.errAccount = true;
            }
          }
          if (state.formState.code == "") {
            state.errArray.errCode = true;
          }
          if (state.formState.password == "") {
            state.errArray.errPassw = true;
          }
          if (
            state.formState.repassword == "" ||
            state.formState.repassword != state.formState.password
          ) {
            state.errArray.errRePassw = true;
          }
          if (state.formState.industry == undefined) {
            state.errArray.errIndustry = true;
          }
          if (state.formState.customTrade == "") {
            state.errArray.errCustom = true;
          }
          setTimeout(() => {
            state.errArray.errName = false;
            state.errArray.errAccount = false;
            state.errArray.errCode = false;
            state.errArray.errPassw = false;
            state.errArray.errRePassw = false;
            state.errArray.errIndustry = false;
            state.errArray.errCustom = false;
          }, 1000);
        });
    };

    const resetForm = () => {
      //重置
      state.formRef.resetFields();
      state.errArray.errName = false;
      state.errArray.errAccount = false;
      state.errArray.errCode = false;
      state.errArray.errPassw = false;
      state.errArray.errRePassw = false;
      state.errArray.errIndustry = false;
      state.errArray.errCustom = false;
    };

    const toLogin = (url) => {
      router.push(url);
    };

    return {
      ...toRefs(state),
      timer,
      handleGetCode,
      onSubmit,
      resetForm,
      registerMethod,
      toLogin,
      readChange,
      inputAccount,
      rePassWord,
      getPhoneCode,
      handleOpenAgreement,
    };
  },
});
</script>
<style scoped>
.beihao {
  position: absolute;
  bottom: 15px;
  font-size: 12px;
  color: #666;
  width: 100%;
  text-align: center;
}
a {
  color: #666;
}
.register-nav {
  width: 100%;
  height: 100%;
  background: rgba(57, 106, 193, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
}
.register-main {
  width: 1200px;
  background: #ffffff;
  border-radius: 0px 4px 4px 0px;
  padding: 48px 50px;
}
.register-left-img1 {
  width: 224px;
  height: 56px;
  display: block;
}
.here-logo {
  width: 100px;
  height: 55px;
}
.register-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -40px;
}
.register-left {
  width: 50%;
  margin-top: 24px;
  height: 480px;
  background-size: 100% 100%;
}

.register-right {
  width: 50%;
  padding-left: 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.register-right-head {
  width: 480px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.register-title {
  height: 36px;
  font-size: 24px;
  font-weight: 500;
  color: #1a1d21;
  line-height: 36px;
}
.register-title-right {
  height: 26px;
  font-size: 18px;
  font-weight: 500;
  color: #1a1d21;
  line-height: 26px;
}
.register-right ::v-deep(.ant-input) {
  width: 480px;
}
.register-right ::v-deep(.ant-input-affix-wrapper) {
  width: 480px;
}

.register-postion-abs {
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 99;
}
.register-postion-abs ::v-deep(.ant-btn) {
  height: 37px;
  border: none;
  font-size: 16px;
  color: #003591;
  line-height: 22px;
  background: none;
}
.register-btn {
  margin-top: 24px;
}
.register-btn ::v-deep(.ant-btn) {
  width: 480px;
  height: 56px;
  font-size: 20px;
  font-weight: 500;
  line-height: 36px;
}
.change-btn {
  height: 26px;
  font-size: 18px;
  font-weight: 500;
  color: #003591;
  line-height: 26px;
  text-align: center;
  margin-top: 25px;
}
.register-check-box {
  margin-top: 12px;
  font-size: 16px;
  color: #535d6c;
  line-height: 24px;
}

@media only screen and (max-width: 1300px) {
  .register-main {
    width: 800px;
    padding: 32px 33px;
  }
  .register-left {
    margin-top: 16px;
    height: 320px;
  }
  .register-left-img1 {
    width: 150px;
    height: 37px;
    top: 27px;
    left: 32px;
  }
  .here-logo {
    width: 66px;
    height: 36px;
  }
  .register-right {
    padding-left: 30px;
  }
  .register-right-head {
    width: 320px;
    margin-bottom: 16px;
  }
  .register-title {
    height: 24px;
    font-size: 16px;
    line-height: 24px;
  }
  .register-title-right {
    height: 17px;
    font-size: 12px;
    line-height: 22px;
  }
  .register-right ::v-deep(.ant-input) {
    width: 320px;
  }
  .register-right ::v-deep(.ant-input-affix-wrapper) {
    width: 320px;
  }
  .register-right
    ::v-deep(.ant-form-item .ant-select, .ant-form-item .ant-cascader-picker) {
    width: 320px !important;
    font-size: 10px;
  }
  .register-postion-abs ::v-deep(.ant-btn) {
    font-size: 10px;
    margin-right: 10px;
  }
  .register-btn {
    margin-top: 16px;
  }
  .register-btn ::v-deep(.ant-btn) {
    width: 320px;
    height: 37px;
    font-size: 14px;
    line-height: 24px;
  }
  .change-btn {
    height: 17px;
    font-size: 14px;
    line-height: 17px;
    margin-top: 16px;
  }
  .register-check-box {
    margin-top: 8px;
    font-size: 10px;
    line-height: 16px;
  }
}
</style>
